module.exports = __webpack_public_path__ + "static/media/rods-cones-tablet.03f8b553.png";